import { ImportTypeConfig } from '#/store/hooks/useForms/Import/types/ImportTypeConfig'

export const ctech: ImportTypeConfig = {
  type: 'ctech',
}
